import React from 'react';
import { useAppTexts } from '../hooks/useAppTexts';

export const Logo = ({ src }) => {
  const appTexts = useAppTexts();

  return <div className="app-logo">{src && <img src={src} alt={appTexts.generic.logo} />}</div>;
};
